import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputComponent {

  @ViewChild('inputElement', { read: ElementRef }) inputElement: ElementRef;

  @Input() fieldValue: any;

  @Input() fieldText: string = "";

  @Input() inputLabel: string = '';

  @Input() labelClass: string = '';

  @Input() inputType: string = 'text';

  @Input() inputClass: string = '';

  @Input() inputPlaceholder: string = '';

  @Input() fControl: FormControl<any> | any;

  @Input() isRequired: boolean = true;

  @Input() isDisable: boolean = false;

  @Input() patternValidationMsg: string = "";

  @Input() maxValueValidationMsg: string = "";

  @Input() minValueValidationMsg: string = "";

  @Input() maxLengthValidationMsg: string = "";

  @Input() minLengthValidationMsg: string = "";

  @Input() customErrorValidationMsg: string = "";

  @Input() acceptFormat: string = "";

  @Output()
  onTextChange = new EventEmitter<any>();

  @Output()
  onInputClick = new EventEmitter<any>();

  sendData() {
    this.fieldValue = this.fControl.value;
    this.onTextChange.emit({ text: this.fieldText, value: this.fieldValue });
  }

  onClick(event: any) {
    this.onInputClick.emit(event);
  }

  onFileUpload() {
    this.inputElement.nativeElement.click();
  }
}
